export default __webpack_public_path__ + "media/no-one-likes-to-be-told-what-to-do-36534.716ac968.mp3";